'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.registerEventHandlers = exports.isEventName = exports.eventNames = exports.props = exports.EVENT_BADGE = exports.EVENT_SUBSCRIBE = exports.EVENT_TITLE_CHANGED = exports.EVENT_UNLOAD = exports.EVENT_REFRESH = exports.EVENT_MOUNT = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _Event = require('./Event');

var _EventHandler = require('./EventHandler');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @type {string}
 */
var EVENT_MOUNT = exports.EVENT_MOUNT = 'app.mount';

/**
 * @type {string}
 */
/**
 * Defines events and event related functionality which are related to the application
 *
 * @module Core/AppEvents
 */

var EVENT_REFRESH = exports.EVENT_REFRESH = 'app.refresh';

/**
 * @type {string}
 */
var EVENT_UNLOAD = exports.EVENT_UNLOAD = 'app.unload';

/**
 * @type {string}
 */
var EVENT_TITLE_CHANGED = exports.EVENT_TITLE_CHANGED = 'app.title_changed';

/**
 * @type {string}
 */
var EVENT_SUBSCRIBE = exports.EVENT_SUBSCRIBE = 'app.subscribe_to_event';

/**
 * @type {string}
 */
var EVENT_BADGE = exports.EVENT_BADGE = 'app.badge';

var events = {
  EVENT_MOUNT: EVENT_MOUNT,

  EVENT_REFRESH: EVENT_REFRESH,
  EVENT_UNLOAD: EVENT_UNLOAD,

  EVENT_TITLE_CHANGED: EVENT_TITLE_CHANGED,

  EVENT_BADGE: { channelType: _Event.CHANNEL_OUTGOING, invocationType: _Event.INVOCATION_FIREANDFORGET },
  EVENT_RESET_SIZE: { channelType: _Event.CHANNEL_OUTGOING, invocationType: _Event.INVOCATION_REQUESTRESPONSE },
  EVENT_SUBSCRIBE: { channelType: _Event.CHANNEL_OUTGOING, invocationType: _Event.INVOCATION_REQUESTRESPONSE }
};

/**
 * @enum
 * @readonly
 * @type {{EVENT_MOUNT: string, EVENT_REFRESH: string, EVENT_UNLOAD: string, EVENT_RESET_SIZE: {channelType: string, invocationType: string}, EVENT_SUBSCRIBE: {channelType: string, invocationType: string}}}
 */
var props = exports.props = events;

/**
 * @readonly
 * @type {Array<string>}
 */
var eventNames = exports.eventNames = (0, _keys2.default)(events).map(function (key) {
  return events[key];
});

/**
 * @method
 *
 * @param {string} name
 * @return boolean
 */
var isEventName = exports.isEventName = function isEventName(name) {
  return eventNames.indexOf(name) !== -1;
};

/**
 * Registers
 *
 * @function
 * @param {WidgetWindowBridge} windowBridge
 * @param {AppClient} app
 */
var registerEventHandlers = exports.registerEventHandlers = function registerEventHandlers(windowBridge, app) {
  (0, _EventHandler.handleOutgoingEvent)(windowBridge, app, EVENT_SUBSCRIBE, events.EVENT_SUBSCRIBE);
  (0, _EventHandler.handleOutgoingEvent)(windowBridge, app, EVENT_BADGE, events.EVENT_BADGE);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-sdk-core/lib/main/javascript/Core/AppEvents.js
// module id = 68
// module chunks = 0